import { QuestionV3ControlTypes } from './enum';
import { QuestionBaseV3 } from './question-base';

export class DropdownQuestionV3 extends QuestionBaseV3 {
  controlType = QuestionV3ControlTypes.DROPDOWN;
  options: {
    key: string;
    name: string;
    value: string;
  }[];
  okText: string;
  cancelText: string;
  defaultValue: number;
  hideEmptyResponse: boolean;

  constructor(options: any = {}) {
    super(options);
    this.options = options['options'] || [];
    this.okText = options['okText'] || 'OK';
    this.cancelText = options['cancelText'] || 'CANCEL';
    this.defaultValue = options['defaultValue'] || void 0;
    this.hideEmptyResponse = options['hideEmptyResponse'] || false;
  }
}
